import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { ShieldOff } from "lucide-react";

import { canAccessModule, readModuleAccess } from "../lib/moduleAccess";

/**
 * Route-level module gate (#1342). Blocks direct navigation to modules the
 * user's role doesn't include; the sidebar filtering in main.tsx hides the
 * same modules from nav. No-op for routes without a moduleScope, and fails
 * open entirely until RBAC is rolled out (rbac_enabled claim).
 */
export function ModuleAccessGuard({
  moduleScope,
  children,
}: {
  moduleScope?: string;
  children: ReactNode;
}) {
  const { t } = useTranslation();
  if (canAccessModule(readModuleAccess(), moduleScope)) return <>{children}</>;
  return (
    <div className="flex-1 flex items-center justify-center p-8" role="alert">
      <div className="max-w-md text-center space-y-3">
        <ShieldOff className="mx-auto h-10 w-10 opacity-40" aria-hidden />
        <h1 className="text-xl font-semibold">{t("shell.noAccess.title")}</h1>
        <p className="text-sm opacity-70">{t("shell.noAccess.body")}</p>
      </div>
    </div>
  );
}
